// extracted by mini-css-extract-plugin
export default {"profile":"ProfilePicture_profile__q5cYT","beat":"ProfilePicture_beat__5wDKM"};